<template>
  <div class="px-4">
    <v-row>
      <v-col>
        <div class="primary1--text headline font-weight-bold">
          ANEXOS
        </div>
      </v-col>
    </v-row>
    <TabelaAnexos :role="'admin_brasil'" />
  </div>
</template>

<script>
import jwtDecode from 'jwt-decode'

import TabelaAnexos from './Shared/TabelaAnexos'
export default {
  components: {
    TabelaAnexos
  },
  data() {
    return {
      // Error Handler
      error: false,
      errObj: {},
      loadingOverlay: false,
      args: ''
    }
  },
  async beforeMount() {
    this.tokenBearer = localStorage.getItem('tokenBearer')
    let decoded = jwtDecode(this.tokenBearer)
    this.role = decoded.role
  }
}
</script>

<style scoped></style>
